import { GetServerSidePropsContext } from 'next';
import { ROUTE_LOGIN } from '../variables/routes';

const getRedirectToLoginUrl = () => {
  return window?.location?.pathname
    ? `/uyelik/giris?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`
    : ROUTE_LOGIN;
};

const getRedirectToLoginUrlSSR = (ctx?: GetServerSidePropsContext) => {
  return ctx?.resolvedUrl ? `/uyelik/giris?redirect=${encodeURIComponent(ctx.resolvedUrl)}` : ROUTE_LOGIN;
};

export async function redirectLoginSSR(ctx?: GetServerSidePropsContext) {
  return {
    redirect: {
      permanent: false,
      destination: getRedirectToLoginUrlSSR(ctx),
    },
  };
}

export async function redirectLogin(router: any) {
  await router.push(getRedirectToLoginUrl());
}
